import { Grid, Typography } from '@mui/material';
import React, { useEffect } from 'react';

import InvoicesClaimed from '../common/InvoicesClaimed';
import InvoicesNotConfirmedNumber from '../common/InvoicesNotConfirmedNumber';
import LastInvoicesADC from '../common/LastInvoicesADC';
import SiiDebt from '../common/SIIDebt';
import SiiMessages from '../common/SiiMessages';

const DashboardADC: React.FC = () => {
  useEffect(() => {}, []);

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={6} md={6}>
          <Typography variant="h5">Pendientes</Typography>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <SiiDebt />
            </Grid>
            <Grid item xs={6}>
              <InvoicesNotConfirmedNumber />
            </Grid>
            <Grid item xs={12}>
              <InvoicesClaimed />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={6} md={6}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <SiiMessages />
            </Grid>
            <Grid item xs={12}>
              <LastInvoicesADC />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default DashboardADC;
